export default "__VITE_ASSET__BCcvX07I__"